/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { FaRocket } from 'react-icons/fa';
import { ROCKET_POOL_ERC20 } from '../constants';
export var GetCollateralRate = createPlugin({
    protocol: 'ROCKETPOOL',
    type: 'GETTER',
    method: 'getCollateralRate',
    supportedContracts: ROCKET_POOL_ERC20,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {},
        },
        output: {
            collateralRate: new FctValue18({ isPreview: true, icon: FaRocket }),
        },
    }); },
});
